import { render, staticRenderFns } from "./AddressOtc.vue?vue&type=template&id=1d73ecb5"
import script from "./AddressOtc.vue?vue&type=script&lang=js"
export * from "./AddressOtc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports